import { GlButton, GlTooltipDirective, GlAnimatedChevronLgDownUpIcon } from '@gitlab/ui';
import { __ } from '~/locale';
import { STATUS_CLOSED, STATUS_MERGED } from '~/issues/constants';
import { BV_HIDE_TOOLTIP } from '~/lib/utils/constants';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import StatusIcon from './mr_widget_status_icon.vue';
import Actions from './action_buttons.vue';
export default {
    name: 'StateContainer',
    components: {
        GlButton,
        GlAnimatedChevronLgDownUpIcon,
        StatusIcon,
        Actions
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glSlotsMixin,
        glListenersMixin
    ],
    props: {
        isCollapsible: {
            type: Boolean,
            required: false,
            default: false
        },
        collapseOnDesktop: {
            type: Boolean,
            required: false,
            default: false
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        status: {
            type: String,
            required: false,
            default: ''
        },
        actions: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        expandDetailsTooltip: {
            required: false,
            type: String,
            default: __('Expand merge details')
        },
        collapseDetailsTooltip: {
            required: false,
            type: String,
            default: __('Collapse merge details')
        }
    },
    emits: [
        'toggle'
    ],
    computed: {
        wrapperClasses () {
            if (this.status === STATUS_MERGED) return 'gl-bg-feedback-info widget-merge-status';
            if (this.status === STATUS_CLOSED) return 'gl-bg-feedback-danger widget-merge-status';
            return null;
        },
        hasActionsSlot () {
            return this.glSlots().actions?.()?.length;
        }
    },
    methods: {
        hideTooltips () {
            this.$root.$emit(BV_HIDE_TOOLTIP);
        }
    }
};
